import React, { Component, Fragment } from "react";
import moment from "moment";
import MaterialTypeListContainer from "../../MaterialTypeListView/MaterialTypeList";
import { Row, Col } from "reactstrap";
import CommonModalStateless from "../../Common/CommonModalStateless";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import { languageService } from "../../../Language/language.service";
import ThisTable from "../../Common/ThisTable";
import { ToastService } from "../../../utils/toastify";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "../../../reduxCURD/actions";
import { getAppMockupsTypes } from "../../../reduxRelated/actions/diagnosticsActions";

class MaterialList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSyncModal: false,
    };
    this.openSyncModal = this.openSyncModal.bind(this);
    this.openResyncModal = this.openResyncModal.bind(this);
    this.closeSyncModal = this.closeSyncModal.bind(this);
    this.postSyncedMaterials = this.postSyncedMaterials.bind(this);
  }

  componentDidMount() {
    this.props.getApplicationlookupss("getlist/wimsMaterialTimestamp");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionType !== this.props.actionType || prevProps.MaterialSyncActionType !== this.props.MaterialSyncActionType) {
      const actionType = this.props.actionType || this.props.MaterialSyncActionType;
      if (actionType === "MATERIALSYNCS_READ_SUCCESS") {
        this.setState({ showSyncModal: true });
      }
      if (actionType === "MATERIALSYNC_CREATE_SUCCESS" || actionType === "MATERIALSYNC_UPDATE_SUCCESS") {
        ToastService.Success(languageService("Materials Synced successfully."));
        this.closeSyncModal();
        if (this.props.getAppMockupsTypes) {
          this.props.getAppMockupsTypes("materialTypes");
        }
        // Refresh the timestamp lookup after successful post implicitly or directly
        this.props.getApplicationlookupss("getlist/wimsMaterialTimestamp");
      }
    }
  }

  getTimestampData() {
    const { applicationlookups, applicationlookupss, applicationlookupsReducer } = this.props;

    // Check direct props first, then check inside the reducer object if mapping didn't flatten
    let source = applicationlookups || applicationlookupss;
    if (!source && applicationlookupsReducer) {
      source = applicationlookupsReducer.applicationlookups || applicationlookupsReducer.applicationlookupss;
    }

    let data = source;
    // Handle potential wrapper if it's { data: [...] }
    if (data && data.data && Array.isArray(data.data)) {
      data = data.data;
    }

    if (Array.isArray(data)) {
      // Find the specific lookup by listName
      return data.find((item) => item.listName === "wimsMaterialTimestamp") || null;
    } else if (data && typeof data === "object" && !data.errorValue) {
      // If it's a single object, verify it's the right one
      if (data.listName === "wimsMaterialTimestamp") return data;
    }
    return null;
  }

  isMaterialsSynced() {
    const timestampData = this.getTimestampData();
    return !!timestampData;
  }

  openSyncModal() {
    this.props.getMaterialSyncs("");
  }

  openResyncModal() {
    const timestampData = this.getTimestampData();
    const opt1 = timestampData ? timestampData.opt1 : null;
    this.props.getMaterialSyncs("?updatedSince=" + encodeURIComponent(opt1));
  }

  closeSyncModal() {
    this.setState({ showSyncModal: false });
  }

  postSyncedMaterials() {
    const data = (this.props.MaterialSyncs && this.props.MaterialSyncs.data) || [];
    if (data.length > 0) {
      this.props.createMaterialSync(data, "data");
    } else {
      ToastService.Error(languageService("No data to sync."));
    }
  }

  render() {
    const materialSyncData = (this.props.MaterialSyncs && this.props.MaterialSyncs.data) || [];
    const isSynced = this.isMaterialsSynced();

    const timestampData = this.getTimestampData();
    const lastSynced = timestampData ? timestampData.opt1 : null;

    return (
      <Fragment>
        <div style={{ padding: "10px", width: "100%" }}>
          <MaterialTypeListContainer
            isIMS={true}
            {...this.props}
            lastSynced={lastSynced}
            imsActionComponent={
              <div style={{ display: "flex", alignItems: "center", gap: "15px", justifyContent: "flex-end" }}>
                {!isSynced ? (
                  <MyButton onClick={this.openSyncModal}>{languageService("Sync Material List")}</MyButton>
                ) : (
                  <MyButton onClick={this.openResyncModal}>{languageService("Refetch")}</MyButton>
                )}
              </div>
            }
          />
        </div>

        {this.state.showSyncModal && (
          <CommonModalStateless
            isOpen={this.state.showSyncModal}
            headerText={isSynced ? languageService("Material list") : languageService("Material List")}
            modalStyle={{ maxWidth: "60vw" }}
            footerContent={
              <div>
                <MyButton onClick={this.closeSyncModal} customStyle={{ margin: "0 10px 0 0" }}>
                  {languageService("Cancel")}
                </MyButton>
                <MyButton onClick={this.postSyncedMaterials} disabled={materialSyncData.length === 0}>
                  {isSynced ? languageService("Update") : languageService("Add")}
                </MyButton>
              </div>
            }
          >
            <div style={{ padding: "15px" }}>
              <ThisTable
                tableColumns={[
                  { Header: languageService("Item No"), accessor: "code" },
                  { Header: languageService("Description"), accessor: "description" },
                  { Header: languageService("Status"), accessor: "opt1.status" },
                  { Header: languageService("Category"), accessor: "opt1.category" },
                ]}
                tableData={materialSyncData}
                pageSize={10}
                minRows={1}
                pagination={true}
                forDashboard={false}
                height={"auto"}
              />
            </div>
          </CommonModalStateless>
        )}
      </Fragment>
    );
  }
}

const getApplicationlookupss = curdActions.getApplicationlookupss;

const actionOptions = {
  create: true,
  update: false,
  read: true,
  delete: false,
  others: {
    getAppMockupsTypes,
    getApplicationlookupss,
  },
};

const variables = {
  MaterialSyncReducer: { MaterialSync: {}, MaterialSyncs: [] },
  diagnosticsReducer: { materialTypes: [] },
  applicationlookupsReducer: { applicationlookups: null, applicationlookupss: [] },
};

export default CRUDFunction(
  MaterialList,
  "MaterialSync",
  actionOptions,
  variables,
  ["MaterialSyncReducer", "diagnosticsReducer", "applicationlookupsReducer"],
  "wims/materials",
);



// WEBPACK FOOTER //
// ./src/components/IMS/MaterialList/MaterialList.jsx